        <template>
  <div
      >
    <b-row
          >
                                    <b-col
                                                                                                >
                            <e-commerce-shop />            </b-col>
                            </b-row>
  </div>
</template>
<script>
/* eslint-disable */
// prettier-ignore
import {
  BRow,
  BCol,
} from 'bootstrap-vue'


                                      import ECommerceShop from '@core/components/e-commerce/e-commerce-shop/ECommerceShop.vue'
                            
export default {
  components: {
    BRow,
    BCol,

                                                          ECommerceShop,
                                          },
  setup() {
    
      },
}
</script>
    